import debug from 'debug';

import { BaseActions } from '../Common/Actions/BaseActions';
import { execAction } from '../Common/Actions/handler';
import { ResponseEither } from '../Common/ResponseEither';
import { INewPolicyRequestParams } from './interfaces/INewPolicyRequestParams';
import { IPolicyRequestParams } from './interfaces/IPolicyRequestParams';
import { PolicyClientRequestBuilder } from './PolicyRequestBuilder';

const log = debug('sunny:PolicyAction');

export class PolicyActions extends BaseActions<PolicyClientRequestBuilder> {
  find(params: IPolicyRequestParams): Promise<ResponseEither<string>> {
    log('Getting information of the Policy');
    return execAction('policy', this.requestBuilder.createPolicyQuery(params));
  }

  findNewPolicy(params: INewPolicyRequestParams): Promise<ResponseEither<string>> {
    log('Getting information of the new Policy');
    return execAction('new Policy', this.requestBuilder.createNewPolicyQuery(params));
  }
}
